export default "__VITE_ASSET__DTDmD0LE__"